/**
 * @implements {import('./Mapper').Mapper}
 */
export class Mapper {
    static toEntity(dto) {}

    static toDto() {}
}
